import {
	APP_INITIALIZER,
	ApplicationConfig,
	ErrorHandler,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Router, Routes } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AnalyticsSentryErrorHandler } from './services/analytics-sentry-error-handler';
import { analyticsFrameworkDiProviders } from './providers/framework-di.providers';
import { REPORT_CARD_AUDIENCE } from '@framework/analytics/tokens/report-card-audience.token';
import { ANALYTICS_CARD_DATA_REF_ORIGIN } from '@framework/analytics/services/analytics-card-data-ref.service';

const routes: Routes = [
	{
		path: ':reportId',
		component: AppComponent,
	},
	{
		path: ':reportId/page/:pageId',
		component: AppComponent,
	},
];

export const appConfig: ApplicationConfig = {
	providers: [
		provideZonelessChangeDetection(),
		// zone.js used to route errors thrown in async callbacks (timers,
		// promises, listeners) to the ErrorHandler; zoneless needs this to keep
		// AnalyticsSentryErrorHandler seeing them.
		provideBrowserGlobalErrorListeners(),
		provideRouter(routes),
		provideAnimations(),
		provideNativeDateAdapter(),
		MatSnackBarConfig,
		...analyticsFrameworkDiProviders,
		{ provide: REPORT_CARD_AUDIENCE, useValue: 'viewer' },
		{
			provide: ANALYTICS_CARD_DATA_REF_ORIGIN,
			useValue: environment.hostName,
		},
		{
			provide: ErrorHandler,
			useClass: AnalyticsSentryErrorHandler,
		},
		...(environment.sentry?.enabled
			? [
					{
						provide: Sentry.TraceService,
						deps: [Router],
					},
					{
						provide: APP_INITIALIZER,
						useFactory: () => () => {},
						deps: [Sentry.TraceService],
						multi: true,
					},
				]
			: []),
	],
};
